'use client';

import { useEffect } from 'react';
import type { RefObject } from 'react';

interface UseHeaderOverlayEffectsParams {
  dropdownRef: RefObject<HTMLDivElement | null>;
  headerRef: RefObject<HTMLElement | null>;
  isMobileOpen: boolean;
  onCartClose: () => void;
  onDropdownClose: () => void;
  onMobileClose: () => void;
}

const useHeaderOverlayEffects = ({
  dropdownRef,
  headerRef,
  isMobileOpen,
  onCartClose,
  onDropdownClose,
  onMobileClose,
}: UseHeaderOverlayEffectsParams) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      const clickedInsideHeader = Boolean(headerRef.current?.contains(target));
      const clickedInsideDropdown = Boolean(dropdownRef.current?.contains(target));

      if (!clickedInsideHeader && !clickedInsideDropdown) {
        onDropdownClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef, headerRef, onDropdownClose]);

  useEffect(() => {
    const handleKey = (event: globalThis.KeyboardEvent) => {
      if (event.key !== 'Escape') {
        return;
      }

      onDropdownClose();
      onCartClose();
      onMobileClose();
    };

    document.addEventListener('keydown', handleKey);

    return () => {
      document.removeEventListener('keydown', handleKey);
    };
  }, [onCartClose, onDropdownClose, onMobileClose]);

  useEffect(() => {
    document.body.style.overflow = isMobileOpen ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileOpen]);
};

export default useHeaderOverlayEffects;
